<template>
  <div class="patentInfo">
    <el-scrollbar>
      <div class="cont">
        <div class="cont-main col999">
          <div class="updateBox flex-between">
            <div class="type">
              <span class="table-title">临时医嘱</span>
              <el-radio-group v-model="searchData.dict_advice_type" @change="getDataList">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button label="163110000">药疗</el-radio-button>
                <el-radio-button label="163120000">处置</el-radio-button>
              </el-radio-group>
              <el-tag type="success" style="margin-right: 10px;">本次费用：{{ totalMoney.toFixed(2) }}，本月费用：{{ medfee_sumamt.toFixed(2) }}</el-tag>
            </div>

            <div class="upButtom">
              <el-dropdown style="margin-right: 10px;">
                <el-button type="primary">
                  打印<el-icon class="el-icon--right"><arrow-down /></el-icon>
                </el-button>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item @click="print(item)" v-for="item in dictList['909100000']" :key="item.code">{{item.name}}</el-dropdown-item>
                    <el-dropdown-item @click="print1('lin')">临时医嘱</el-dropdown-item>
                    <el-dropdown-item @click="printInfo('check')">检查申请单</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>

              <el-button-group style="margin-right: 10px;">
                <el-button type="success" @click="openWeight('addLongIerm')">新增医嘱</el-button>
                <el-button type="primary" @click="addTao('addLongIerm')">导入组套</el-button>
                <el-button type="primary" @click="addHistory('addLongIerm')">导入历史</el-button>
              </el-button-group>

              <el-button-group>
                <el-button type="primary" @click="delData()">批量删除</el-button>
                <el-button type="primary" @click="handleSelectionChange('1')">一键执行</el-button>
                <el-button type="primary" @click="handleSelectionChange('2')">取消执行</el-button>
              </el-button-group>

            </div>
          </div>
          <div class="tables">
            <el-table ref="multipleTable" @selection-change="handleSelectionChangeDel" :row-class-name="tableRowClassName" size="small" v-loading="tableLoading"
              row-key="id" :data="tableData" border max-height="300">
              <el-table-column type="selection" align="center" width="42" />
              <el-table-column width="50" fixed type="index" label="序号" align="center" />
              <el-table-column width="60" prop="dict_advice_type_name" label="类别" align="center" />

              <el-table-column width="80" label="医保报销" align="center">
                <template #default="scope">
                  <el-checkbox v-model="scope.row.pay_typeCheck" size="small" label="" @change="(val) => {
                    adviceDoCheType(val, scope.row)
                  }
                    "></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="drug" label="医嘱内容" width="280" show-overflow-tooltip />
              <el-table-column width="100" label="单次剂量" show-overflow-tooltip>
                <template #default="scope">
                  <span>
                    {{ scope.row.dosage }}{{ scope.row.dict_dosage_unit_name }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column width="100" label="用药途径" property="dict_use_way_name" show-overflow-tooltip>
              </el-table-column>
              <el-table-column width="60" prop="num" label="数量" align="center" />
              <el-table-column width="120" property="medi_spec" label="规格" show-overflow-tooltip />

              <el-table-column width="80" property="name" label="包装" align="center">
                <template #default="scope">
                  <span>
                    {{ scope.row.min_package_num }}{{ scope.row.min_unit_name }}/{{ scope.row.min_package_unit_name }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column width="120" property="company" label="厂家" show-overflow-tooltip />
              <el-table-column width="70" prop="sell_price" label="单价" align="center" />
              <el-table-column width="60" prop="dict_first_unit_name" label="单位" align="center" />
              <el-table-column width="90" prop="doctor.name" label="开嘱医生" align="center" />
              <el-table-column width="90" prop="do_user_id_name" label="执行护士" align="center" />

              <el-table-column width="150" label="执行时间">
                <template #default="scope">
                  <el-time-picker v-model="scope.row.do_time" size="small" value-format="HH:mm:ss" format="HH:mm:ss"
                    placeholder="执行时间">
                  </el-time-picker>
                  <!-- <el-time-picker
                    v-model="scope.row.do_time"
                    :disabled="scope.row.is_do"
                    value-format="HH:mm:ss"
                    format="HH:mm:ss"
                    placeholder="执行时间"
                  >
                  </el-time-picker> -->
                </template>
              </el-table-column>
              <el-table-column width="70" label="执行" align="center">
                <template #default="scope">
                  <el-checkbox v-model="scope.row.is_do" size="small" label="" @change="(val) => {
                    adviceDoChe(val, scope.row)
                  }
                    "></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column width="80" label="来源" align="center">
                <template #default="scope">
                  <el-tag>{{ scope.row.source_name }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注" show-overflow-tooltip />
              <el-table-column fixed="right" label="操作" width="150" align="center">
                <template #default="scope">
                  <el-link type="primary" @click="modParient(scope.row)">修改</el-link>
                  <el-link type="danger" @click="delParient(scope.row)">删除</el-link>
                  <el-link type="primary" @click="sortData(scope.row, 1)"><el-icon>
                      <Top />
                    </el-icon></el-link>
                  <el-link type="primary" @click="sortData(scope.row, 2)"><el-icon>
                      <Bottom />
                    </el-icon></el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-scrollbar>

    <BaseDialog title="修改记录" :isshow="isHistory" @handleShow="(val) => {
      isHistory = val
    }
      " width="84%" height="auto">
      <el-table size="small" :data="historyTable" border style="margin-top: 20px">
        <el-table-column fixed width="160px" prop="updated_time" label="修改时间" />
        <el-table-column fixed prop="doctor.name" label="修改人" />
        <el-table-column fixed prop="type_content" label="类别" />
        <el-table-column width="100px" prop="id" label="数据ID" />
        <el-table-column width="300px" prop="advice_content" label="医嘱内容" show-overflow-tooltip />
        <el-table-column width="150px" prop="dict_advice_type" label="医嘱类型编码" />
        <el-table-column width="150px" prop="dict_advice_type_name" label="医嘱类型名称" />
        <el-table-column width="150px" prop="dict_drug" label="药品编码" show-overflow-tooltip />
        <el-table-column width="120px" prop="drug" label="药品名称" show-overflow-tooltip />
        <el-table-column width="100px" prop="standard" label="规格" show-overflow-tooltip />
        <el-table-column width="90px" prop="dosage" label="单次用量" />
        <el-table-column width="140px" prop="dict_dosage_unit" label="单次用量单位" />
        <el-table-column width="150px" prop="dict_use_type" label="用药途径编码" />
        <el-table-column width="150px" label="用药途径名称" />
        <el-table-column width="120px" prop="dict_frequency" label="执行频次" />
        <el-table-column width="90px" prop="num" label="数量" />
        <el-table-column width="90px" prop="num_unit_name" label="单位" />
        <el-table-column width="160px" label="是否按收费组套收费" />

        <el-table-column width="120px" label="收费组套ID" />
        <!-- <el-table-column
          width="150px"
          prop="charge_group_name"
          label="收费组套名称"
        /> -->
        <el-table-column width="150px" label="收费组套名称" />
        <el-table-column width="210px" label="记录当前组套下选择的项目ID" />
        <el-table-column width="120px" prop="self_provided" label="个人库存" />
        <el-table-column width="120px" prop="start_time" label="开嘱时间" />
        <el-table-column width="120px" prop="do_time" label="执行时间" />
        <el-table-column width="120px" prop="check_time" label="核对时间" />
        <el-table-column width="120px" prop="create_doctor_id" label="开嘱医生ID" />
        <el-table-column width="140px" prop="create_doctor_id_name" label="开嘱医生姓名" />
        <el-table-column width="120px" prop="do_user_id" label="执行护士Id" />
        <el-table-column width="120px" prop="do_user_id_name" label="执行护士姓名" />
        <el-table-column width="120px" prop="check_user_id" label="核对护士ID" />
        <el-table-column width="120px" prop="check_user_id_name" label="核对护士姓名" />
        <el-table-column width="120px" prop="dict_drug_type" label="药品类型编码" />
        <el-table-column width="140px" prop="dict_drug_type_name" label="药品类型名称" />
        <!-- <el-table-column width="120px" prop="advice_content" label="执行标识" />
        <el-table-column width="120px" prop="advice_content" label="核对标识" />
        <el-table-column width="120px" prop="advice_content" label="更新标识" /> -->
        <!-- <el-table-column
          width="150px"
          prop="advice_content"
          label="是否外部导入数据"
        /> -->
        <el-table-column width="140px" prop="source_name" label="数据来源类型" />
        <el-table-column width="150px" label="开嘱医生签名图片" />
        <el-table-column width="150px" label="执行护士签名图片" />
        <el-table-column width="150px" label="核对护士签名图片" />
        <!-- <el-table-column
          width="180px"
          prop="advice_content"
          label="标识属于同一组套的颜色"
        /> -->
        <el-table-column width="120px" prop="advice_group_id" label="医嘱组套ID" />
        <el-table-column width="120px" prop="advice_group_name" label="医嘱组套名称" />
        <el-table-column width="160px" prop="is_custom" label="是否自定义编辑医嘱" />
      </el-table>
    </BaseDialog>

    <batchLongIerm v-if="isBatchLongIerm" ref="batchLongIermRef" :patientId="patientId" :recordId="recordId" :type="2"
      @refreshDataList="getDataList"></batchLongIerm>
    <addLongIerm v-if="isAddLongIerm" ref="addLongIermRef" :patientId="patientId" :recordId="recordId"
      @refreshDataList="getDataList"></addLongIerm>
    <viewLongIerm v-if="isViewLongIerm" ref="viewLongIermRef" :patientId="patientId" @refreshDataList="getDataList">
    </viewLongIerm>
    <jing ref="jingRef"></jing>
    <puTong ref="puTongRef"></puTong>
    <linShi ref="linShiRef"></linShi>
    <check ref="checkRef"></check>
    <addTaoModal v-if="isAddTao" ref="addTaoModalRef" :patientId="patientId" @refreshDataList="getDataList">
    </addTaoModal>
    <addHistory v-if="isAddHistory" ref="addHistoryRef" :patientId="patientId" @refreshDataList="getDataList">
    </addHistory>
    <selectPrint v-if="printFlag" ref="selectPrintRef" @refreshDataList="printData"></selectPrint>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted, nextTick, watch, getCurrentInstance } from 'vue'
import service from '@/utils/request'
import { getConstHei, clone,gitDictList } from '@/utils/tool.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import batchLongIerm from '@/views/patient/Details/advice/batchLongIerm.vue'
import addLongIerm from './addLongIerm.vue'
import viewLongIerm from './viewLongIerm1.vue'
import jing from './jing.vue'
import puTong from './puTong.vue'
import linShi from './linShi.vue'
import check from './check.vue'
import BaseDialog from '@/components/Dialog/index.vue'
import dayjs from 'dayjs'
import addTaoModal from './addTaoModal'
import addHistory from './addHistory'
import selectPrint from '@/components/selectPrint'
export default {
  name: 'programme',
  components: {
    addHistory,
    addLongIerm,
    batchLongIerm,
    BaseDialog,
    viewLongIerm,
    jing,
    puTong,
    linShi,
    check,
    addTaoModal,
    selectPrint
  },
  props: ['patientData', 'searchListData'],
  emits: ['stepsUpdate'],
  setup(props, ctx) {
    const { proxy } = getCurrentInstance()
    const state = reactive({
      ruleForm: {},
      infoHei: '',
      searchData: {
        date: '2022-3-15',
        drug_type: '3',
        dict_advice_type: ''
      },
      dictList:[],
      pageData: {
        currentPage: 1,
        pageSize: 20,
        totalSum: 0,
      },
      tableData: [],
      totalMoney: 0,
      historyTable: [],
      isHistory: false,
      isBatchLongIerm: false,
      batchLongIermRef: null,
      isAddLongIerm: false,
      addLongIermRef: null,
      viewLongIermRef: null,
      isViewLongIerm: false,
      tableLoading: false,
      patientId: 0,
      recordId: 0,
      printInfo: {},//精二打印数据
      isAddTao: false,
      addTaoModalRef: null,
      isAddHistory: false,
      addHistoryRef: null,
      multipleSelection: [],
      printList: [],//打印数据
      printFlag: false,
      tableSelected:[],
      medfee_sumamt: 0, // 本月结算总费用
    })

    watch(
      () => props.patientData.patient_id,
      (val) => {
        console.log(val)
        if (val) {
          state.patientId = val
          state.recordId = props.patientData.record_id
        } else {
          state.patientId = 0
          state.recordId = 0
        }
        state.searchData.date = props.searchListData.time
        getDataList()
      }
    )

    onMounted(() => {
      state.infoHei = getConstHei()
      if (props.patientData.patient_id) {
        state.patientId = props.patientData.patient_id
        state.recordId = props.patientData.record_id
      } else {
        state.patientId = 0
        state.recordId = 0
      }
      state.searchData.date = props.searchListData.time
      state.medfee_sumamt = props.patientData.medfee_sumamt
      getDataList()
      initDatas()
    })
     // 获取字典
     const initDatas = async () => {
      state.dictList = await gitDictList([
        '909100000',
      ])
      console.log(state.dictList)
    }
   
    const getDataList = async () => {
      state.searchData.patient_id = state.patientId
      state.searchData.record_id = state.recordId
      state.tableLoading = true
      let res = await service.post(
        '/api/dialysis_record/tmp_list',
        state.searchData
      )
      state.tableLoading = false
      if (res.code === 0) {
        state.tableData = res.data.records
        state.tableData.forEach(item => {
          if (item.pay_type == '1') {
            item.pay_typeCheck = true
          } else {
            item.pay_typeCheck = false
          }
        })
        let total = state.tableData.reduce((pre, cur) => {
          return pre + (Number(cur.sell_price) * Number(cur.num))
        }, 0)
        if (isNaN(total)) {
          state.totalMoney = 0
        } else {
          state.totalMoney = total
        }

        state.pageData.totalSum = res.data.total
      }
    }
    const tableRowClassName = ({ row, rowIndex }) => {
      console.log(row)
      if (row.is_do == 1) {
        return 'danger-row'
      }
      //  else if (row.check_cash == false) {
      //   return 'warning-row'
      // }
      return ''
    }
    const handleSizeChange = (val) => {
      state.pageData.pageSize = val
      getDataList()
    }
    const handleCurrentChange = (val) => {
      state.pageData.currentPage = val
      getDataList()
    }

    const modParient = (item) => {
      doThing('2', item)
    }
    //一键执行
    const handleSelectionChange = (code) => {
      if (state.tableData.length > 0) {
        let arr = []
        state.tableData.forEach(item => {
          arr.push(item.id)
        })
        console.log(arr)
        let data = {
          id_list: arr
        }
        let title = ''
        if (code == 1) {
          title = '执行'
        } else {
          title = '取消执行'
        }
        ElMessageBox.confirm('共' + arr.length + '条医嘱，确认全部' + title + '吗？', '操作提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let url = ''
            if (code == 1) {
              url = '/api/dialysis_record/do_tmp_advice_list'
            } else {
              url = '/api/dialysis_record/cancel_do_tmp_advice_list'
            }
            let res = await service.post(url, data)
            if (res.code === 0) {
              ElMessage.success(res.msg)
              getDataList()
            }
          })
          .catch(() => {
          })
      } else {
        ElMessage.error('暂无医嘱！')
      }

    }

    const delParient = async (item) => {
      let res = await service.post('api/dialysis_record/checkSettleStatus', {
        bed_id: props.patientData.id,
      })
      if (res.code === 0) {
        if (res.data.is_settle) {
          ElMessageBox.confirm('删除后无法撤销，确认删除吗？', '操作提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              let res = await service.post('/api/dialysis_record/tmp_delete', {
                id: item.id,
              })
              if (res.code === 0) {
                ElMessage.success(res.msg)
                getDataList()
              }
            })
            .catch(() => { })

        } else {
          ElMessage.error('请先撤销结算')
        }

      }

    }
    const adviceDoChe = async (val, row) => {
      const item = clone(row)
      if (!val) {
        let res = await service.post('/api/dialysis_record/cancel_do_tmp', {
          id: item.id,
        })
        if (res.code === 0) {
          ElMessage.success(res.msg)
          ctx.emit('stepsUpdate')
        }
        getDataList()
      } else {
        if (!item.do_time) {
          item.do_time = dayjs(new Date()).format('HH:mm:ss')
        }
        let res = await service.post('/api/dialysis_record/do_tmp', {
          id: item.id,
          do_time: item.do_time,
        })
        if (res.code === 0) {
          ElMessage.success(res.msg)
          ctx.emit('stepsUpdate')
        }
        getDataList()
      }
    }
    const adviceDoCheType = async (val, row) => {
      console.log(row, row.pay_typeCheck)
      let type = ''
      if (row.pay_typeCheck) {
        type = '1'
      } else {
        type = '2'
      }
      let res = await service.post('/api/dialysis_record/set_pay_type', {
        id: row.id,
        pay_type: type
      })
      if (res.code === 0) {
        ElMessage.success(res.msg)
      }
      getDataList()
    }
    const adviceCheckChe = async (val, row) => {
      const item = clone(row)
      if (!val) {
        let res = await service.post('/api/dialysis_record/cancel_check_tmp', {
          id: item.id,
        })
        if (res.code === 0) {
          ElMessage.success(res.msg)
        }
        getDataList()
      } else {
        if (!item.check_time) {
          item.check_time = dayjs(new Date()).format('HH:mm:ss')
        }
        let res = await service.post('/api/dialysis_record/check_tmp', {
          id: item.id,
          check_time: item.check_time,
        })
        if (res.code === 0) {
          ElMessage.success(res.msg)
        }
        getDataList()
      }
    }
    const historyParient = async (item) => {
      let res = await service.post('/api/dialysis_record/get_his_list', {
        data_id: item.id,
      })
      if (res.code === 0) {
        state.historyTable = res.data.records
        state.isHistory = true
      }
    }

    const openWeight = (type) => {
      if (!state.patientId || state.patientId === 0) {
        ElMessage({
          message: '请先选择患者',
          type: 'warning',
        })
        return
      }
      switch (type) {
        case 'batchLongIerm':
          state.isBatchLongIerm = true
          nextTick(() => {
            state.batchLongIermRef.initData()
          })
          break
        case 'addLongIerm':
          doThing('1', '')
          break
      }
    }
    const doThing = async (code, data) => {
      let res = await service.post('api/dialysis_record/checkSettleStatus', {
        bed_id: props.patientData.id,
      })
      if (res.code === 0) {
        if (res.data.is_settle) {
          if (code == 1) {
            state.isAddLongIerm = true
            nextTick(() => {
              state.addLongIermRef.initData()
            })
          } else if (code == 2) {
            state.isViewLongIerm = true
            nextTick(() => {
              state.viewLongIermRef.initData(data, '0')
            })
          } else if (code == 4) {
            state.isAddTao = true
            nextTick(() => {
              state.addTaoModalRef.initData('lin', state.recordId)
            })
          } else if (code == 3) {
            state.isAddHistory = true
            nextTick(() => {
              state.addHistoryRef.initData(props.patientData)
            })
          }
        } else {
          ElMessage.error('请先撤销结算')
        }
      }
    }
    //全选数据批量删除
    const handleSelectionChangeDel = (e)=>{
      console.log(e)
      state.tableSelected = e
    }
    // 批量删除
    const delData = ()=>{
      if(state.tableSelected.length>0){
          let ids = state.tableSelected.map((e)=> e.id)
          ElMessageBox.confirm('共' + ids.length + '条医嘱，确认全部删除吗？', '操作提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let data = {
              id_list:ids
            }
            let res = await service.post('/api/dialysis_record/deleteTempTreatAdviceMulti', data)
            if (res.code === 0) {
              ElMessage.success(res.msg)
              getDataList()
              state.tableSelected = []
            }
          })
          .catch(() => {
          })
      }else{
        ElMessage.error('请选择要删除的医嘱！')
      }
    }
    //调整顺序
    const sortData = async (row, code) => {
      let param = {
        id: row.id,
        type: code
      }
      let res = await service.post('/api/advice/sort_record_advice', param)
      if (res.code === 0) {
        ElMessage.success(res.msg)
        getDataList()
      }
    }
    const print = async (item) => {
      let type = item.code
      let url = '/api/printData/getRecordDrugList'
      let res = await service.post(url, {
        type: type,
        record_id: state.recordId
      })
      if (res.code === 0) {
          if (res.data.drug_list.length == 0) {
            ElMessage.error('暂无打印药品');
          } else {
            proxy.$refs.puTongRef.info = res.data
            proxy.$refs.puTongRef.info.typeName = item.name.substring(0, 2)
            proxy.$refs.puTongRef.initData(res.data)
            nextTick(() => {
              proxy.$refs.puTongRef.print()
            })
          }
        } 
    }
    const printInfo = async (title) => {
      let type = ''
      let url = ''
        type = '3'
        url = '/api/printData/getRecordDrugList'
      let res = await service.post(url, {
        type: type,
        record_id: state.recordId
      })
      if (res.code === 0) {
       
          if (res.data.drug_list.length == 0) {
            ElMessage.error('暂无打印信息');
          } else {
            proxy.$refs.checkRef.info = res.data
            proxy.$refs.checkRef.initData(res.data)
            nextTick(() => {
              proxy.$refs.checkRef.print()
            })
          }
        
      }
    }
    
    const printData = (info) => {
      console.log(info)
      if (info.type1 == 'jing') {
        console.log('jing')
        proxy.$refs.jingRef.info = info
        proxy.$refs.jingRef.initData(info)
        nextTick(() => {
          proxy.$refs.jingRef.print()
        })
      } else {
        console.log('打印普通')
        proxy.$refs.puTongRef.info = info
        proxy.$refs.puTongRef.initData(info)
        nextTick(() => {
          proxy.$refs.puTongRef.print()
        })
      }
    }
    const print1 = async (title) => {
      state.searchData.patient_id = state.patientId
      state.searchData.record_id = state.recordId
      let res = await service.post('/api/dialysis_record/tmp_list', state.searchData)
      if (res.code === 0) {
        if (res.data.records.length > 0) {


          if (title == 'lin') {
            console.log(props.patientData.patient)
            let data = {
              name: props.patientData.patient.name,
              age: props.patientData.patient.age,
              dict_sex_name: props.patientData.patient.dict_sex_name,
              drug_list: res.data.records
            }
            proxy.$refs.linShiRef.initData(data)
            nextTick(() => {
              proxy.$refs.linShiRef.print()
            })
          } else {
            proxy.$refs.checkRef.info = res.data
            proxy.$refs.checkRef.initData(res.data)
            nextTick(() => {
              proxy.$refs.checkRef.print()
            })
          }
        } else {
          ElMessage.error('暂无打印信息！')
        }
      }
    }
    const addTao = () => {
      doThing(4, '')

    }
    const addHistory = () => {
      doThing(3, '')
      // state.isAddHistory = true
      // nextTick(() => {
      //   state.addHistoryRef.initData(props.patientData)
      // })
    }
    return {
      ...toRefs(state),
      openWeight,
      doThing,
      getDataList,
      handleSizeChange,
      handleCurrentChange,
      modParient,
      delParient,
      adviceDoChe,
      adviceCheckChe,
      historyParient,
      print,
      print1,
      addTao,
      printInfo,
      adviceDoCheType,
      handleSelectionChange,
      tableRowClassName,
      sortData,
      addHistory,
      printData,
      handleSelectionChangeDel,
      delData,
      initDatas
    }
  },
}
</script>

<style scoped lang="scss">
.tables {
  margin-top: 0;
}

.el-link {
  margin-right: 8px;
}

.el-table ::v-deep .DisabledSelection .cell .el-checkbox__inner {
  position: relative;
}

.el-table ::v-deep .DisabledSelection .cell:before {
  content: "一键执行";
  position: absolute;
  right: 11px;
}

.upButtom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-table {
  &:deep(.el-date-editor.el-input) {
    width: 120px;
  }
}

.updateBox {
  margin-bottom: 6px;
  margin-top: 6px;

  .el-radio-group {
    margin-right: 20px;
  }
}

.type {
  font-size: 18px;
  color: #000000;
  display: flex;
  align-items: center;
  .table-title {
    margin-right: 20px;
  }
}

.parient-tag {
  .el-tag {
    margin-right: 10px;
  }
}

.checkBox {
  position: relative;
  z-index: 2;
}
</style>
<style>
.el-table .warning-row {
  background: #fff3e0;
}

.el-table .danger-row {
  background: #ffebee;
}
</style>